import React from 'react';
import { Link } from 'react-router-dom';

export default () => (
	<div className='Service-CN'>
		<h4>
			OUR SERVICES
		</h4>
		<p>
			At New Wave Property Group, we turn vacant and underused infill lots into multi-unit rental apartments… whether the lot is completely bare or comes with an existing dwelling that stays while we add new housing beside or behind it. Our focus is infill development… creating rental buildings that respect the street, serve the community, and perform over the long term. As property developers, project managers and property managers, we coordinate every moving part of the process so the build stays aligned with the plan, the budget, and the timeline.
		</p>
		<p>Once construction is complete, you can lean on us to help set up the next phase… whether that’s rental management, lease-up support, or connecting you with our recommended financial professionals to structure an exit strategy that maximizes returns.
		</p>
		<Link class="proj-button" to='/contactpage'>
			<button className="project-button">GET IN TOUCH</button>
		</Link>
	</div>
);
